
<div>
  <template v-if="!showCreateForm">
    <DataPage
      ref="historyTable"
      :columns="columns"
      :fetch-callback="fetchHistory"
      :model="EntityProductModel"
      :header-underline="false"
      :show-footer="false"
      has-row-actions
      headless
    >
      <template #actionButtons="{ item }">
        <div
          v-if="item.status !== 'disabled'"
          class="d-inline-block position-relative"
          @mouseenter="hoveredItemId = item.id"
          @mouseleave="hoveredItemId = null"
        >
          <b-button
            size="xs"
            variant="outline-secondary"
            class="dropdown-ellipses dropdown-toggle ml-2"
            @click.stop="clickedItemId = clickedItemId === item.id ? null : item.id"
          >
            <Icon icon="ellipsis-v" size="18"/>
          </b-button>
          <div
            v-if="hoveredItemId === item.id || clickedItemId === item.id"
            class="history-action-popover"
          >
            <b-button class="dropdown-item" size="sm" @click.prevent="disable(item)">
              <Icon icon="x-circle" class="mr-2" size="14"/>
              {{ __('buttons.disable') }}
            </b-button>
          </div>
        </div>
      </template>
    </DataPage>

    <div class="d-flex justify-content-start mt-3">
      <b-button variant="primary" size="sm" @click="showCreateForm = true">
        <Icon icon="plus-circle" size="14" class="mr-2"/>
        {{ __('buttons.add-new') }}
      </b-button>
    </div>
  </template>

  <template v-else>
    <b-row>
      <SelectField
        v-model="form.productId"
        class="col-12"
        name="product_id"
        :label="__('common.product')"
        :options="productOptions"
        :readonly="true"
      />
      <TextField
        v-model="form.commission"
        class="col-4"
        name="commission"
        :label="__('common.agent-commission') + ', %'"
        type="number"
      />
      <TextField
        v-model="form.grossAmount"
        class="col-4"
        name="gross_amount"
        :label="__('common.gross-commission')"
        type="number"
      />
      <TextField
        v-model="form.feeAmount"
        class="col-4"
        name="fee_amount"
        :label="__('entities.fee')"
        type="number"
      />
      <DateField
        v-model="form.activeFrom"
        class="col-4"
        name="active_from"
        :label="__('entities.active-from')"
      />
    </b-row>

    <div class="d-flex justify-content-between mt-3">
      <b-button size="sm" variant="secondary" @click="cancelCreate">
        {{ __('buttons.cancel') }}
      </b-button>
      <b-button size="sm" variant="primary" @click="submitCreate">
        <Icon icon="save" size="14" class="mr-2"/>
        {{ __('buttons.save') }}
      </b-button>
    </div>
  </template>
</div>
